'use client'

import { useRegionalMarket } from '@/useRegionalMarket'
import { withRegionalMarketErrorBoundary } from '@/ErrorBoundary/RegionalMarketErrorBoundary'

/**
 * Keeps persisted `currency` / `country` aligned with the storefront implied by the
 * current host. Uses the unified regional market hook to prevent race conditions.
 * Invariant: US site → USD in the client store; UK site → GBP.
 */
function StorefrontCurrencyGuardImpl() {
  useRegionalMarket({ enableCurrencySync: true })
  return null
}

export const StorefrontCurrencyGuard = withRegionalMarketErrorBoundary(
  StorefrontCurrencyGuardImpl,
  { source: 'storefront_currency_guard' }
)
